var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shadow-title parallax-top-shadow",style:({
    top: ((_vm.topOffset / 2) + "px")
  })},[_vm._v(" "+_vm._s(this.$route.name)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }